import React, { Fragment, useState, useEffect } from "react"

import MissingImage from "@/public/images/image-missing.png"

import { useTranslation } from "react-i18next"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import { addDataLayer } from "../ProductDetailView/analytics"
import { getShortenedUrlwithGeneral } from "@/utils/helper"
import { getConfig } from "@/constants/config"
import { NumericFormat } from "react-number-format"
import Toaster from "@/components/core/Toaster/Toaster"
import OrderSample from "../OrderSample"
import { READY_TO_SHIP_LABEL, SHIPS_IN_LABEL, SPECIAL_ORDER_LABEL } from "@/constants/index";
import infoIcon from "@/public/icons/tooltip.svg"
import { useDispatch } from "react-redux";
import { setLeadTimeTab } from "@/store/features/pdpSlice";

const discounts = [50, 60, 65, 70, 75, 80];

const ProductSummary = props => {
  const productSummaryData = props.productSummaryDetails
  const [showOrderSample, setShowOrderSample] = useState(false)
  const [badgeDetailsTooltip, setbadgeDetailsTooltip] = useState("")
  const { t } = useTranslation()
  const [config, setConfig] = useState({})
  const { disableEcommerce } = props
  const dispatch = useDispatch()
  const { general = {} } = config
  const { cartLandingPagePath } = general
  const cartUrl = getShortenedUrlwithGeneral(cartLandingPagePath ?? "", general)
  const [toaster, setToaster] = useState({ show: false, message: null })
  const [selectedItem, setSelectedItem] = useState([])
  const [showShippingTooltip, setShowShippingTooltip] = useState(false)
  const leadTimeDescription = productSummaryData["ProductASLeadTimeCopy_s"]
  const shippingInfoTooltip = productSummaryData["SKUAnnSacksNonStock_b"] ?  props?.authorData?.nonStockShippingInfo : props?.authorData?.inStockShippingInfo

  const showToaster = selectedData => {
    setSelectedItem(selectedData)
    setToaster({
      ...toaster,
      show: true,
      message: ToasterMsg(),
    })
    setTimeout(
      () => setToaster({ ...toaster, show: false, message: null }),
      3000
    )
  }

  useEffect(() => {
    getConfig().then(config => {
      setConfig(config)
    })
  }, [])

  useEffect(() => {
    dispatch(setLeadTimeTab({ leadTimeDescription, shippingInfoTooltip }))
  }, [leadTimeDescription, shippingInfoTooltip])

  const productCategoryType = props.productCategoryType ?? ""
  const isSamplesPdp = productCategoryType.toLowerCase() === "samples"
  let itemCountMessage = `${t("kf.pdp.label.itemAdded")} `
  const selecteditemCount = selectedItem.length
  const ToasterMsg = () => (
    <>
      {selecteditemCount} {itemCountMessage}{" "}
      <a href={cartUrl}>{t("kf.pdp.label.yourCart")}</a>.
    </>
  )

  const badgeDetailsTooltipHandler = (data, i) => {
    setbadgeDetailsTooltip("tooltip_" + i)
    addDataLayer({
      title: "sutable for:icons mouseover",
      productInfo: props?.analyticsProductInfo,
      toolTipProps: {
        isToolTip: true,
        toolTipValue: `sutable for:${data.badge_name.toLowerCase()}`,
      },
    })
  }

  const onShowOrderSample = () => {
    addDataLayer({
      title: props?.staticTexts?.orderSample.toLowerCase(),
      productInfo: props?.analyticsProductInfo,
    })
    toggleOrderSample()
  }

  const toggleOrderSample = () => {
    setShowOrderSample(!showOrderSample)
  }

  if (showOrderSample) {
    document.getElementsByTagName("BODY")[0].style.overflow = "hidden"
  } else {
    document.getElementsByTagName("BODY")[0].removeAttribute("style")
  }

  let badgeDescription = []
  let totalBadgeInfoLength = props.productSummaryDetails["SKUBadgeInfo_ss"]
    ? props.productSummaryDetails["SKUBadgeInfo_ss"].length
    : 0
  if (totalBadgeInfoLength > 0) {
    let getBadgeInfo = ""
    let getBadgeArray = []
    let badgeDescriptionTmp = []
    let i
    for (
      i = 0;
      i < props.productSummaryDetails["SKUBadgeInfo_ss"].length;
      i++
    ) {
      if (props.productSummaryDetails["SKUBadgeInfo_ss"][i] !== "") {
        getBadgeInfo = ""
        getBadgeArray = []
        badgeDescriptionTmp = []
        getBadgeInfo = props.productSummaryDetails["SKUBadgeInfo_ss"][i]
        getBadgeArray =
          getBadgeInfo.indexOf("|") > -1 ? getBadgeInfo.split("|") : ""
        if (getBadgeArray.length > 0) {
          badgeDescriptionTmp["badge_name"] = getBadgeArray[0]
            ? getBadgeArray[0]
            : ""
          badgeDescriptionTmp["badge_description"] = getBadgeArray[1]
            ? getBadgeArray[1]
            : ""
          badgeDescriptionTmp["badge_url"] = getBadgeArray[2]
            ? getBadgeArray[2]
            : ""
          badgeDescription[i] = badgeDescriptionTmp
        }
      }
    }
  }

  let title = props.pdpProductCustomerFacingName ?? ""
  if (productSummaryData["productName_s"]) {
    title = productSummaryData["productName_s"]
  }

  const getDesignByTitle = () => {
    let productDesignerS = productSummaryData["ProductDesigner_s"],
      productDesignerByText = ""
    if (
      productDesignerS &&
      title.toLowerCase().indexOf(productDesignerS.toLowerCase()) === -1
    ) {
      productDesignerByText = productDesignerS
        ? props?.staticTexts?.by + " " + productDesignerS
        : ""
    }
    return productDesignerByText
  }

  return (
    <Fragment>
      <div className="col-12 product-summary__product-summary-block p-0">
        <div className="product-summary" id="product-summary-wrapper">
          {productSummaryData["ProductPageTitle_s"] && (
            <div className="product-summary__title">
              {productSummaryData["ProductPageTitle_s"]}
            </div>
          )}
          <div className="product-summary__desc">
            <h1 className="product-summary__desc">{title} </h1>
            <span className="product-summary__desc">{getDesignByTitle()}</span>
          </div>
          {/* Price Details */}
          {!isSamplesPdp && !props.isDiscontinued && (
            <>
              {props.price > 0 && (
                <div className="product-summary__price">
                  <span className="sr-only">{`${props.discountedPrice ? "Discounted":"Current"} price ${props.currencySign} ${props.discountedPrice > 0
                          ? props.discountedPrice
                          : props.price}`}</span>
                  <span className="product-summary__price-first" aria-hidden="true">
                    <NumericFormat
                      value={
                        props.discountedPrice > 0
                          ? props.discountedPrice
                          : props.price
                      }
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={props.currencySign}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </span>
                  <span className="product-summary__price-sec">
                    {props?.priceTag}
                  </span>
                </div>
              )}
              {props.discountedPrice > 0 && (
                <div className="product-summary__discount">
                  <span className="sr-only">{`Original price ${props.currencySign} ${props.price}`}</span>
                  <span className="product-summary__discount-price" aria-hidden={true}>
                    <NumericFormat
                      value={props.price}
                      displayType="text"
                      thousandSeparator={true}
                      prefix={props.currencySign}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </span>
                  <span className="product-summary__price-sec">
                    {props?.priceTag}
                  </span>
                  {
                    props.discountPercent > 0
                      ? !props.discountTitle?.startsWith("ASTPR_")
                        ? (
                          <span className="product-summary__percent-off">
                            {props.isType === "absolute"
                              ? props.currencySign + props.discountPercent + props.staticTexts.percentOff
                              : props.discountPercent + "% " + props.staticTexts.percentOff}
                          </span>
                        )
                        : null
                      : props.discountedPrice > 0 && props.isType === "relative" &&
                        discounts.includes((Math.round(Number((100 - ((props.discountedPrice / props.price) * 100)).toFixed(0)))))
                        ? (
                          <span className="product-summary__percent-off">
                            {(Math.round(Number((100 - ((props.discountedPrice / props.price) * 100)).toFixed(0)))) + "%"}{" "}
                            {props.staticTexts.percentOff}
                          </span>
                        )
                        : null
                  }
                </div>
              )}
            </>
          )}
          {!productSummaryData["noBadge_b"] && (
          <div className="product-summary__shipping">
            {productSummaryData["SKUAnnSacksNonStock_b"] ? (
              <>
                <span className="product-summary__shipping-status">
                  {SPECIAL_ORDER_LABEL + ": "}
                </span>
                <span className="product-summary__shipping-time">
                  {SHIPS_IN_LABEL + " " + productSummaryData["LeadTimeRange_s"]}
                </span>
              </>
            ) : (
              <span className="product-summary__shipping-status">
                {READY_TO_SHIP_LABEL}
              </span>
            )}
            <span
              className="product-summary__shipping-time-block"
              onMouseEnter={() => setShowShippingTooltip(true)}
              onMouseLeave={() => setShowShippingTooltip(false)}
              onFocus={() => setShowShippingTooltip(true)}
              onBlur={() => setShowShippingTooltip(false)}
              tabIndex={0}
            >
              <img
                src={infoIcon?.src}
                role="tooltip"
                tabIndex={0}
                className="shipingtooltip"
                alt="Shipping Info"
                aria-hidden="true"
              />
              {showShippingTooltip && (
                <div
                id="shipping-tooltip"
                className="tooltipWrapper"
                role="tooltip"
                tabIndex={-1}
                >
                  <div
                    className="tooltip__container"
                    dangerouslySetInnerHTML={{
                      __html: shippingInfoTooltip,
                    }}
                  />
                </div>
              )}
            </span>
          </div>
          )}
          <div className="product-summary__details">
            {productSummaryData["ProductDescriptionSmall_s"]
              ? productSummaryData["ProductDescriptionSmall_s"]
              : ""}
          </div>
          {!disableEcommerce &&
            !props.isDiscontinued &&
            productSummaryData["SKUSamples_ss"] && (
              <div className="product-summary__button-block">
                <button
                  className="kf-react-button product-summary__button"
                  type="button"
                  onClick={onShowOrderSample}
                >
                  {props?.staticTexts?.orderSample}
                </button>
              </div>
            )}
          <div className="product-summary__icons-block">
            {badgeDescription !== "" ? (
              <div className={`product-summary__icons-part-first`}>
                {badgeDescription.map((badgeDetails, i) => (
                  <React.Fragment key={`badgeDetails-${i}`}>
                    <span className="product-details__list-text">
                      <img
                        onError={e => (e.target.src = MissingImage?.src)}
                        src={badgeDetails.badge_url}
                        className="product-summary__icons"
                        onMouseOver={() =>
                          badgeDetailsTooltipHandler(badgeDetails, i)
                        }
                        onMouseLeave={() => setbadgeDetailsTooltip("")}
                      />
                    </span>
                    <div
                      className={`product-details__tooltip-main-block product-details__list-tooltip${
                        badgeDetailsTooltip === "tooltip_" + i
                          ? "--show"
                          : "--hide"
                      }`}
                    >
                      <div className="product-details__list-tooltip-wrapper">
                        <ToolTip
                          label="Suitable For"
                          message={badgeDetails.badge_name}
                        />
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {toaster.show && <Toaster message={<ToasterMsg />} />}
      {!props.isDiscontinued && showOrderSample && (
        <OrderSample
          closePopup={toggleOrderSample}
          productSummaryData={productSummaryData}
          showToaster={showToaster}
          config={config}
          {...props}
        />
      )}
    </Fragment>
  )
}

export default ProductSummary
